module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label",
    class: {
      'label_big': _vm.bigLabel
    }
  }, [_vm._v(_vm._s(_vm.label)), (_vm.required) ? _c('sup', [_vm._v("*")]) : _vm._e(), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49144f8f","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/form/components/components/label/Label.vue
// module id = b0c899c07e91f3138a72
// module chunks = 89